export default {
  path: '/service',
  component: () => import('../../views/servicePage/service-router.vue'),
  children: [
    {
      path: '',
      name: 'Service',
      component: () => import('../../views/servicePage/pages/Service.vue'),
      meta: {
        name: 'navigationDrawer.service',
        icon: '/icons/service.svg',
        auth: true
      }
    },
    {
      path: 'service-create',
      name: 'ServiceCreate',
      component: () => import('../../views/servicePage/pages/ServiceCreate.vue'),
      meta: {
        name: 'navigationDrawer.service',
        icon: '/icons/service.svg',
        auth: true
      }
    },
    {
      path: 'service-edit/:id',
      name: 'ServiceEdit',
      component: () => import('../../views/servicePage/pages/ServiceEdit.vue'),
      meta: {
        name: 'navigationDrawer.service',
        icon: '/icons/service.svg',
        auth: true
      }
    },
    {
      path: 'service-detail/:id',
      name: 'ServiceDetail',
      component: () => import('../../views/servicePage/pages/ServiceDetail.vue'),
      meta: {
        name: 'navigationDrawer.service',
        icon: '/icons/service.svg',
        auth: true
      }
    }
  ]
}
